import styled from "styled-components/macro";

const DividerHorizontalStyled = styled.div.attrs({ className: "mb-4" })`
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray};
`;

export default DividerHorizontalStyled;
